import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import CustomDrawer from '@ui-components/Drawer/CustomDrawer';
import CustomList from '@ui-components/List/CustomList';
import CustomIconButton from '@ui-components/IconButton/CustomIconButton';
import OpsLogo from '@assets/images/qler_logo.svg';
import { useNavigate, useLocation } from 'react-router-dom';
import { menuConfig } from './menuConfig';
import {
  PARTNER_ROUTE_PATH,
  CONSULTS_ROUTE_PATH,
} from '../../routers/routePaths';
import ExpandableMenu from './ExpandableMenu';
import { hasRole } from '../login/storageUtility';

const drawerWidth = 180;
const miniDrawerWidth = 60;

const SideNav: React.FC<{
  isOpen: boolean;
  onToggle: () => void;
}> = ({ isOpen, onToggle }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    if (location.pathname.includes('facility')) {
      setOpen(!open);
    }
  }, []);

  return (
    <Box className="flex">
      <CustomDrawer
        variant="permanent"
        anchor="left"
        hideBackdrop
        miniVariant
        miniWidth={miniDrawerWidth}
        fullWidth={drawerWidth}
        open={isOpen}
        onToggle={onToggle}
      >
        <Box className="pb-12 text-align-left">
          <CustomIconButton
            id="logo"
            onClick={() => {
              if (hasRole(['ops-admin'])) {
                navigate(PARTNER_ROUTE_PATH, { replace: true });
                history.replaceState(null, '', PARTNER_ROUTE_PATH);
              } else {
                navigate(CONSULTS_ROUTE_PATH, { replace: true });
                history.replaceState(null, '', CONSULTS_ROUTE_PATH);
              }
            }}
            icon={<OpsLogo />}
          />
        </Box>

        <CustomList
          className={`custom-list ${isOpen ? '' : 'padding-for-mini-varient'}`}
        >
          {menuConfig
            // .filter(
            //   (menuItem) =>
            //     !(menuItem.name === 'Intake Forms' && !hasRole(['ops-admin']))
            // )
            .map((menuItem) => (
              <ExpandableMenu
                key={menuItem.name}
                menuItem={menuItem}
                open={open}
                setOpen={(o) => setOpen(o)}
              />
            ))}
        </CustomList>
      </CustomDrawer>
    </Box>
  );
};

export default SideNav;
